// @ts-ignore
import { ROLES } from "@infinitaslearning/module-he-common";
import type React from "react";
import { useTranslation } from "react-i18next";
import boyStudy from "../../assets/images/svg/boy_study.svg";
import { RoleComponent } from "../RoleComponent";
import type { AdditionalsItemProps } from "./AdditionalsItem.model";
import {
  StyleAuthor,
  StyleCard,
  StyleCardContainer,
  StyleCardContent,
  StyleCardContentContainer,
  StyleCardImage,
  StyleCircleIcon,
  StyleContentItem,
  StyleIcon,
  StyleImage,
  StyleLink,
  StyleSpan,
  StyleTitle,
} from "./AdditionalsItem.styled";

export const AdditionalsItem: React.FC<AdditionalsItemProps> = ({ item }) => {
  const { t } = useTranslation("home");
  return (
    <StyleCardContainer>
      <StyleCard dataCy="item-list-item">
        <RoleComponent allowedRoles={[ROLES.TEACHER]}>
          <StyleCircleIcon>
            <StyleIcon className="icon-bookmark" />
          </StyleCircleIcon>
        </RoleComponent>
        <StyleLink to={`/${item.id}`}>
          <StyleCardImage>
            <StyleImage alt={item.title} src={boyStudy} />
          </StyleCardImage>
          <StyleCardContentContainer>
            <StyleCardContent>
              <StyleTitle>{item.title}</StyleTitle>
              <StyleContentItem>
                <StyleSpan>{t("additionals.authorLabel", "Author")}: &nbsp;</StyleSpan>
                <StyleAuthor>{item.title}</StyleAuthor>
              </StyleContentItem>
            </StyleCardContent>
          </StyleCardContentContainer>
        </StyleLink>
      </StyleCard>
    </StyleCardContainer>
  );
};
